import React from 'react';
import { Helmet } from 'react-helmet-async';
import { AlertTriangle } from 'lucide-react';

export const Disclaimer: React.FC = () => {
  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      <Helmet>
        <title>Disclaimer - Asphalt Calculator</title>
        <meta name="description" content="Legal disclaimer for the Asphalt Calculator website. Understand the limitations and proper use of our calculator." />
      </Helmet>

      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-xl p-8">
        <div className="flex items-center mb-8">
          <AlertTriangle className="h-8 w-8 text-blue-600 mr-3" />
          <h1 className="text-3xl font-bold text-slate-800">Disclaimer</h1>
        </div>

        <div className="prose max-w-none">
          <p className="text-slate-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Calculation Accuracy</h2>
            <p className="text-slate-600 mb-4">
              While we strive to provide accurate calculations, the results from our asphalt calculator are estimates only.
              Actual material requirements may vary based on specific site conditions, material properties, and local factors.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Professional Advice</h2>
            <p className="text-slate-600 mb-4">
              This calculator is intended as a planning tool only and should not replace professional judgment.
              We strongly recommend consulting with qualified construction professionals, engineers, or contractors
              for final material specifications and quantities.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">No Warranty</h2>
            <p className="text-slate-600 mb-4">
              The information and calculations provided are on an "as is" basis. We make no representations or
              warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability,
              or availability of the calculator or the information contained on the website for any purpose.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Limitation of Liability</h2>
            <p className="text-slate-600 mb-4">
              In no event will we be liable for any loss or damage including without limitation, indirect or
              consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits
              arising out of, or in connection with, the use of this calculator.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Contact Information</h2>
            <p className="text-slate-600">
              If you have any questions about this Disclaimer, please contact us at:
              <br />
              Email: info@asphaltcalculator.online
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};